export const checkValidPhone = (phone) => {
  const regPhone = /^[0-9]+$/;
  if (regPhone.test(phone)) {
    return true;
  }
};
